module.exports = __webpack_public_path__ + "img/join.939deb9b.svg";